import { Grid } from '@mui/material'
import { Text } from 'components/texts'
import React, { Component } from 'react'
import { Input } from 'components/forms/components'
import { CursoEscolarSelect, ItemsSelect } from 'components/forms/components/Select/custom'

/**
 * Esta es la plantilla para cuando se busque por los datos basicos del alumno en una inscripcion
 */
export default class InscripcionAlumnosTemplate extends Component {
    
    /**
     * Constructor
     * 
     * @param {Object} props 
     */
    constructor(props) {
        super(props)
    }

    /**
     * Render
     *
     * @returns {Component}
     */
    render() {
        const { register, errors, setValue } = this.props
        return (
            <>
                <Grid container mt={2} mb={1}>
                    <Text fontWeight={'bold'}>Según datos de:</Text><br />
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Input label="Nombre" width={"100%"} name={"nombre"} register={register} errors={errors} uppercase/>
                    </Grid>

                    <Grid item xs={4}>
                        <Input label="Primer apellido" width={"100%"} name={"apellido1"} register={register} errors={errors} uppercase/>
                    </Grid>

                    <Grid item xs={4}>
                        <Input label="Segundo apellido" width={"100%"} name={"apellido2"} register={register} errors={errors} uppercase/>
                    </Grid>

                    <Grid item xs={6}>
                        <ItemsSelect name={"id_actividad"} keyValue={"actividad"} register={register} errors={errors} wantToReset={this.props.reset} searcheable />
                    </Grid>

                    <Grid item xs={6}>
                        <CursoEscolarSelect name={"id_curso_escolar"} register={register} errors={errors} wantToReset={this.props.reset} defaultValue={null} setValue={setValue} searcheable />
                    </Grid>
                </Grid>
            </>
        )
    }
}
